export type SgCurrencyPairPickerState = {
  value: string;
  isRequired: boolean; // can be empty at the beginning, but should not be empty when submitting (ENTER, TAB, blur)

  editedValue: string;

  hasError: boolean;
  isTooltipOpen: boolean;

  isLoading: boolean;
  allCurrencyPairs: string[];
  filteredCurrencyPairs: string[];
  selectedCurrencyPair: string;
};

export function initialState(value: string, isRequired: boolean, currencyPairs: string[]): SgCurrencyPairPickerState {
  return {
    value,
    isRequired,

    editedValue: value,
    selectedCurrencyPair: value,

    hasError: false,
    isTooltipOpen: false,

    isLoading: false,
    allCurrencyPairs: currencyPairs,
    filteredCurrencyPairs: currencyPairs.slice(0, 7),
  };
}
